import React from "react";
import { NoChatContainer } from "./style";

const NoChat = () => {
  return (
    <NoChatContainer>
      <img src="image/hush-logo.png" alt="logo" />
      <p>Hush Chat</p>
      <span>
        Send and Receive Messages with friends and family Message are highly
        encrypted and end to end
      </span>
    </NoChatContainer>
  );
};
export default NoChat;
